<template>
    <div class="layout-container table-special">
        <el-tabs type="border-card">
            <el-tab-pane label="话题库管理">
                <div style="background: #ffffff;position:relative;">
                    <div class="search-condition-con" :class="'show'">
                        <div class="search-condition">
                            <span class="label" >话题名称</span>
                            <div class="input-condition" >
                                <el-input v-model="condition.topic_name" placeholder="可输入话题关键词"></el-input>
                            </div>
                        </div>
                    </div>
                    <div class="btn-condition">
                        <el-button type="primary" @click="handleSearch()">查 询</el-button>
                        <el-button  @click="resetSearch()">清空条件</el-button>
                        <el-button
                            type="primary"
                            icon="el-icon-plus"
                            @click="handleTopicsAss()"
                            v-permission="'operating.house-topic.house-topic-bank.assigned'"
                        >话题分配</el-button>
                        <el-button
                        type="primary"
                        icon="el-icon-plus"
                        @click="handleAdd()"
                        v-permission="'operating.house-topic.house-topic-bank.create'"
                        >新增话题</el-button>
                    </div>
                </div>
               
            <el-table
                    :data="list"
                    style="width: 100%"
                    :highlight-current-row="true"
                    stripe
                    tooltip-effect="dark"
                    ref="multipleTable"
                    v-loading="isLoading"
                    header-cell-class-name="table-back"
                    class="list-table"
            >
                <el-table-column  label="话题名称" prop="topic_name"   align="center"></el-table-column>
                <el-table-column  label="话题描述" prop="topic_desc" width="300"  align="center">
                    <template slot-scope="scope">
                        <p class="ellips2" :title="scope.row.topic_desc">{{scope.row.topic_desc}}</p>
                    </template>
                </el-table-column>
                <el-table-column  label="调用次数" prop="call_num"  align="center"></el-table-column>
                <el-table-column  label="关联题库问答数" prop="ask_banks_num"  align="center"></el-table-column>
                <el-table-column  label="添加人" prop="operator"  align="center"></el-table-column>
                <el-table-column  label="添加时间" prop="created_at"  align="center"></el-table-column>
                <el-table-column label="操作"   width="300px" align="center">
                    <template slot-scope="scope">
                        <el-button v-permission="'operating.house-topic.house-topic-bank.edit'"  size="mini" @click="openEdit(scope.row)"
                            >编辑</el-button>
                        <el-button v-permission="'operating.house-topic.house-topic-bank.delete'"  size="mini" @click="handleDelete(scope.row.id)"
                            >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
             <template v-if="list.length > 0">
                <el-pagination
                    background
                    layout="total,prev, pager, next"
                    :current-page="condition.page"
                    :total="condition.total"
                    :page-size="condition.per_page"
                    @current-change="currentChange"
                ></el-pagination>
            </template>
        </el-tab-pane>
    </el-tabs>
    <add-topic ref="topicAddRef" :callback="initData" />
    <topics-assigned ref="topicsAssRef" :callback="initData"></topics-assigned>
    </div>
</template>
<style>
    td a:link{
        color: #606266;
    }
    td a:visited{
        color: #606266;
    }
</style>
<script>
    import {getBanklList,deleteBankItem} from '@/service/topicBank'
    import { getSite } from "@/service/site";
    import addTopic from './add';
    import topicsAssigned from './topicsAssigned'
    export default {
        components: { addTopic, topicsAssigned },
        name: "List",
        data () {
            return {
                list: [],
                condition: {
                   topic_name:'',
                    total: 0,
                    per_page: 10,
                    page: 1,
                },
                isLoading: false,
                siteAll:[],
            }
        },
        mounted () {
            this.initData()
            this.getSiteList();
        },
        methods: {
            async getSiteList() {
                await getSite({ owned:1, agent_status: 0, per_page: 1000 }).then((data) => {
                    this.siteAll = data.data;
                });
              
            },
            handleSearch() {
                this.condition.page=1
                this.initData();
            },
            resetSearch() {
                this.condition = {
                    topic_name:'',
                    per_page: 10,
                    page: 1,
                }
                this.initData();
            },
            handleAdd() {
                this.$refs.topicAddRef && this.$refs.topicAddRef.openMenu()
            },
            handleTopicsAss(){
                this.$refs.topicsAssRef && (this.$refs.topicsAssRef.siteList = this.siteAll)
                this.$refs.topicsAssRef.openMenu()
            },
           openEdit(item){
                this.$refs.topicAddRef && 
                // ( Object.assign(this.$refs.topicAddRef.formList = item)) &&
                // (this.$refs.topicAddRef.title = "编辑话题") &&
                // (this.$refs.topicAddRef.topicId = item.id) &&
                this.$refs.topicAddRef.openMenu(item.id)
           },
            currentChange(index) {
                this.condition.page = index;
                this.initData();
            },
            async initData() {
                this.list=[]
                await getBanklList(this.condition).then((data) => {
                    this.condition.total=data.total
                    this.list = data.data
                })
                this.isLoading = false
            },
           handleDelete(id) {
                this.$confirm("是否确认删除该话题？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    deleteBankItem(id)
                    .then(() => {
                        this.$message({
                        type: "success",
                        message: "删除成功"
                        });
                        this.initData();
                    })
                    .catch(err => {
                        this.$message({
                        type: "error",
                        message: err.message || "删除失败"
                        });
                    });
                });
            },
        }
    }
</script>

<style scoped>
.list-table {
    padding: 0 20px;
    box-sizing: border-box;
}
.baikeCat .el-select{
    width:48%;
    float:left;
}
.ellips2{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}
</style>



















